import { createContext, useContext } from 'react'

export interface RejectionLabels {
  title?: string
  subjectLabel?: string
  reasonLabel?: string
  reasonPlaceholder?: string
  reasonRequiredText?: string
  caseText?: string
  confirmLabel?: string
  cancelLabel?: string
}

export interface CancelConfirmationLabels {
  message?: string
  subtext?: string
  confirmLabel?: string
  cancelLabel?: string
}

export interface ResolutionConfig {
  errorText?: string
  errorSubtext?: string
  successText?: string
  rejectionLabels?: RejectionLabels
  cancelConfirmationLabels?: CancelConfirmationLabels
}

export const ResolutionConfigContext = createContext<ResolutionConfig | null>(null)

export const useResolutionConfig = () => useContext(ResolutionConfigContext)
